import { Suspense, type ReactNode } from "react";
import { Skeleton } from "@academia-hub/ui";

/**
 * Route-level Suspense boundary for the lazy-loaded page modules in `routes.tsx`. The fallback
 * mirrors a typical page's shape (header + content block) rather than a bare spinner, per
 * `17_UI_VISUAL_DESIGN_SYSTEM.md` §18: "Loading states should use skeletons matching final
 * layout."
 */
export function RouteSuspense({ children }: { children: ReactNode }) {
  return (
    <Suspense
      fallback={
        <div className="flex flex-col gap-6 p-6">
          <div className="flex flex-col gap-2">
            <Skeleton className="h-4 w-40" />
            <Skeleton className="h-7 w-64" />
          </div>
          <Skeleton className="h-48 w-full" />
        </div>
      }
    >
      {children}
    </Suspense>
  );
}
